/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { AppWaldenViewModel } from 'walden-fast/routes/app/walden-view';
import type { Tab } from '../tabs';

export interface WaldenViewPageSignature {
  Args: {
    model: AppWaldenViewModel;
    tabs: Tab[];
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default templateOnlyComponent<WaldenViewPageSignature>();
